import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-qq-fill", label: "QQ" },
  { icon: "ri-tiktok-fill", label: "抖音" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100 mt-16">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-xl" />
              </span>
              <span className="text-xl font-extrabold text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                吃瓜网站
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200">
              专注娱乐新闻与热点八卦的资讯分享平台，让你第一时间了解娱乐圈的那些事。
            </p>
            <div className="flex items-center gap-2 mt-4">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-100 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors"
                >
                  <i className={`${s.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h5 className="text-background-50 font-bold mb-4">快速导航</h5>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-primary-400 transition-colors">
                  搜索资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-background-50 font-bold mb-4">热门分类</h5>
            <ul className="space-y-2.5 text-sm">
              {categories.slice(0, 5).map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="hover:text-primary-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="text-background-50 font-bold mb-4">友情链接</h5>
            <ul className="space-y-2.5 text-sm">
              <li className="hover:text-primary-400 transition-colors cursor-pointer">娱乐观察站</li>
              <li className="hover:text-primary-400 transition-colors cursor-pointer">影视风向标</li>
              <li className="hover:text-primary-400 transition-colors cursor-pointer">星闻速递</li>
              <li className="hover:text-primary-400 transition-colors cursor-pointer">热点聚合</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© {new Date().getFullYear()} 吃瓜网站 · 娱乐资讯分享平台 · 内容均为演示用途</p>
          <p className="flex items-center gap-4">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}